module.exports = __webpack_public_path__ + "assets/img/WechatIMG62.8dcf7af9.png";